import React, { ComponentPropsWithoutRef } from "react";

interface IconProps extends ComponentPropsWithoutRef<"svg"> {
  width?: string;
  height?: string;
  color?: string;
}

export const LogoIcon = ({ width, height, color = "#fff" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 1000 744"
    >
      <g>
        <path
          fill={color}
          d="M673.5,335.8l198.5,0.4c21.8,0,42.3,8.6,57.7,24c15.4,15.5,23.9,36,23.8,57.9c0,21.8-8.5,42.3-24,57.7
                c-15.4,15.4-35.9,23.9-57.7,23.9h-0.1l-198.5-0.4c-21.8,0-42.3-8.6-57.7-24c-15.4-15.5-23.9-36-23.8-57.9
                c0.1-45,36.7-81.5,81.7-81.5H673.5 M673.6,308.8c0,0-0.1,0-0.2,0c-59.9,0-108.6,48.5-108.7,108.5c-0.1,60.1,48.4,108.9,108.5,109
                l198.5,0.4c0,0,0.1,0,0.2,0c60,0,108.6-48.5,108.7-108.5c0.1-60.1-48.4-108.9-108.5-109L673.6,308.8L673.6,308.8z"
        />
      </g>
      <circle fill={color} cx="123.8" cy="418" r="108.8" />
      <circle fill={color} cx="671.9" cy="417.5" r="108.8" />
      <path
        fill={color}
        d="M347.9,527c-61,0-104.5-48.3-104.5-109.8c0-61,43.8-109.4,104.5-109.4c44.7,0,79.1,25.8,93.8,63.5L406.9,386 c-9.8-25-29.5-40.2-59-40.2c-39.7,0-66.4,29.5-66.4,71.3c0,42.2,26.6,71.7,66.4,71.7c26.2,0,44.2-12.3,55.3-33.6l36.1,12.7 C423.7,503.2,391,527,347.9,527z"
      />
      <path
        fill={color}
        d="M476.5,447.5V352h-34.8v-38h34.8v-40.3h38.1V314h49.2v38.1h-49.2v90.1c0,27.5,5.7,40.6,30.3,40.6h19.7v38.1h-29.1 C493.7,520.9,476.5,497.5,476.5,447.5z"
      />
      <g>
        <path
          fill={color}
          d="M697.9,52.1h37.7V257h-37.7v-31.2c-8.9,16.2-30.4,37.3-70.2,37.3c-56,0-99.4-47.1-99.4-108.7c0-61.3,43.4-108.3,99.4-108.3 c39.8,0,61.3,21.5,70.2,37.3V52.1z M697.9,154.3c0-41.4-27.2-70.6-66.1-70.6c-38.9,0-65.7,29.2-65.7,70.6c0,41.8,26.8,71,65.7,71 C670.8,225.3,697.9,196.1,697.9,154.3z"
        />
      </g>
      <path
        fill={color}
        d="M23.1,108.6c0-35.6,30.2-64.7,78.4-64.7c66.9,0,85.2,51.6,85.2,51.6l-31,19.7c0,0-13.9-33.6-54.1-33.6	c-27.9,0-41,10.7-41,25.8c0,13.1,6.8,21.7,29.1,24.6l33.8,4.1c50.5,6.6,70,29.9,70,60.6c0,35.6-29.1,66.4-85.6,66.4	c-73.6,0-90.7-53.7-90.7-53.7L47,190.1c0,0,14.3,35.2,60.5,35.2c36.6,0,48.2-12.7,48.2-27.9c0-13.5-7.6-21.7-33.4-25l-33.8-4.1	C43.8,162.6,23.1,140.1,23.1,108.6z"
      />
      <path
        fill={color}
        d="M475.7,146.7c0-42.6-13.8-64.7-46.5-64.7c-35.7,0-51.2,24.2-51.2,71.3V257h-37.6V146.7c0-42.6-13.9-64.7-46.6-64.7	c-35,0-49.9,22.9-49.9,68v106.9H205V51.2h37.8l-0.4,29.4c7.1-15.2,21.5-36.8,57.2-36.8c35.3,0,57.2,17.2,68.4,53.7l6-15.6	c7.1-15.2,26.5-38.1,62.2-38.1c47.7,0,78.2,31.1,78.2,99.6v113.5h-38.8L475.7,146.7L475.7,146.7z"
      />
      <path
        fill={color}
        d="M963,218.8c-24.6,0-30.3-13.1-30.3-40.6V87.6h49.2V46.3h-49.2V9.6h-38.1v36.7H861h-1.2h-8.6c-31.1,0-48.8,10.6-59,34V52.1	h-38.1v204.7h38.1V138.1c0.8-36.9,18-50.4,53.7-50.4H861v-0.1h33.6v95.9c0,50,17.2,73.3,59,73.3h29.1v-38.1H963V218.8z"
      />
      <g>
        <path
          fill={color}
          d="M32.8,598h23.6v18.8c6.4-14.5,17.3-22.6,36.6-22.6h6.1v25.7h-9.4c-22.1,0-32.8,9.9-33.3,32.8v73.7H32.8V598z"
        />
        <path
          fill={color}
          d="M124.5,670.7c3.3,21.3,19.3,35.8,40.6,35.8c18,0,29.2-9.4,35.3-21.6l22.6,8.4c-10.2,21.8-29.5,36.8-57.9,36.8		c-37.9,0-64.8-30-64.8-68.1c0-37.9,27.2-67.8,63.5-67.8c35.3,0,62.7,27.7,62.7,67.6c0,3.3-0.5,8.9-0.5,8.9L124.5,670.7L124.5,670.7		z M125.3,650.6h78c-4.1-21.3-20.3-32.8-39.4-32.8C144.6,617.9,129.3,631.1,125.3,650.6z"
        />
        <path
          fill={color}
          d="M344.2,598h23.6v128.3h-23.6v-19.6c-5.6,10.2-19.1,23.4-43.9,23.4c-35.1,0-62.2-29.5-62.2-68.1c0-38.4,27.2-67.8,62.2-67.8		c24.9,0,38.4,13.5,43.9,23.4V598z M344.2,662.1c0-25.9-17-44.2-41.4-44.2s-41.2,18.3-41.2,44.2c0,26.2,16.8,44.5,41.2,44.5		S344.2,688.2,344.2,662.1z"
        />
        <path fill={color} d="M393.3,548.5h23.6v177.8h-23.6V548.5z" />
        <path
          fill={color}
          d="M508.4,680.9v-59.2h-21.6V598h21.6v-38.1H532V598h30.5v23.6H532v55.9c0,17,3.6,25.2,18.8,25.2H563v23.6h-18		C519,726.3,508.4,711.8,508.4,680.9z"
        />
        <path
          fill={color}
          d="M591.2,546.7c8.9,0,16,6.9,16,16s-7.1,16-16,16s-16-6.9-16-16C575.2,553.6,582.3,546.7,591.2,546.7z M579.5,598h23.6v128.3		h-23.6V598z"
        />
        <path
          fill={color}
          d="M821.6,658c0-26.4-11.9-40.1-34-40.1c-24.1,0-38.9,15-38.9,44.2v64.3h-23.6V658c0-26.4-11.9-40.1-34-40.1		c-23.6,0-38.9,14.2-38.9,42.2v66.3h-23.6V598h23.6v19.8c4.8-9.4,19.6-23.6,43.7-23.6c23.9,0,41.2,10.7,48.8,33.3l4.1-9.7		c4.8-9.4,19.6-23.6,43.7-23.6c32.3,0,52.8,19.3,52.8,61.7v70.4h-23.6L821.6,658L821.6,658z"
        />
        <path
          fill={color}
          d="M885.9,670.7c3.3,21.3,19.3,35.8,40.6,35.8c18,0,29.2-9.4,35.3-21.6l22.6,8.4c-10.2,21.8-29.5,36.8-57.9,36.8		c-37.9,0-64.8-30-64.8-68.1c0-37.9,27.2-67.8,63.5-67.8c35.3,0,62.7,27.7,62.7,67.6c0,3.3-0.5,8.9-0.5,8.9L885.9,670.7L885.9,670.7		z M886.6,650.6h78c-4.1-21.3-20.3-32.8-39.4-32.8C905.9,617.9,890.7,631.1,886.6,650.6z"
        />
      </g>
    </svg>
  );
};

export const StreamIcon = (props: IconProps) => {
  return (
    <svg version="1.1" width={props.width} height={props.height} viewBox="0 0 32 32">
      <path
        fill="#fff"
        d="M23.512 9.512c-2.349 0-3.702-1.928-4.894-3.631-0.927-1.322-1.728-2.464-2.84-2.464-1.096 0-1.89 1.135-2.809 2.446-1.197 1.71-2.553 3.649-4.926 3.649-2.349 0-3.701-1.928-4.894-3.631-0.927-1.322-1.728-2.464-2.839-2.464v-2.036c1.722 0 2.818 1.563 3.878 3.075 1.089 1.553 2.117 3.020 3.855 3.020 1.761 0 2.793-1.475 3.886-3.037 1.052-1.504 2.141-3.059 3.849-3.059 1.723 0 2.818 1.563 3.879 3.075 1.089 1.553 2.118 3.020 3.855 3.020 1.761 0 2.794-1.475 3.887-3.037 1.052-1.504 2.14-3.059 3.848-3.059v2.036c-1.097 0-1.89 1.135-2.81 2.446-1.196 1.71-2.552 3.649-4.925 3.649v0z"
      ></path>
      <path
        fill="#fff"
        d="M23.512 19.683c-2.349 0-3.702-1.928-4.894-3.631-0.927-1.322-1.728-2.464-2.84-2.464-1.096 0-1.89 1.134-2.809 2.447-1.197 1.71-2.553 3.649-4.926 3.649-2.349 0-3.701-1.928-4.894-3.631-0.927-1.322-1.728-2.464-2.839-2.464v-2.036c1.722 0 2.818 1.563 3.878 3.075 1.089 1.553 2.117 3.020 3.855 3.020 1.761 0 2.793-1.475 3.886-3.037 1.052-1.504 2.141-3.059 3.849-3.059 1.723 0 2.818 1.563 3.879 3.075 1.089 1.553 2.118 3.020 3.855 3.020 1.761 0 2.794-1.475 3.887-3.037 1.052-1.504 2.14-3.059 3.848-3.059v2.036c-1.097 0-1.89 1.134-2.81 2.446-1.196 1.71-2.552 3.649-4.925 3.649v0z"
      ></path>
      <path
        fill="#fff"
        d="M23.512 29.855c-2.349 0-3.702-1.928-4.894-3.631-0.927-1.322-1.728-2.464-2.84-2.464-1.096 0-1.89 1.135-2.809 2.447-1.197 1.71-2.553 3.649-4.926 3.649-2.349 0-3.701-1.928-4.894-3.631-0.927-1.322-1.728-2.464-2.839-2.464v-2.036c1.722 0 2.818 1.563 3.878 3.075 1.089 1.553 2.117 3.020 3.855 3.020 1.761 0 2.793-1.475 3.886-3.037 1.052-1.504 2.141-3.059 3.849-3.059 1.723 0 2.818 1.563 3.879 3.075 1.089 1.553 2.118 3.020 3.855 3.020 1.761 0 2.794-1.475 3.887-3.037 1.052-1.504 2.14-3.059 3.848-3.059v2.036c-1.097 0-1.89 1.135-2.81 2.447-1.196 1.71-2.552 3.649-4.925 3.649v0z"
      ></path>
    </svg>
  );
};

export const StoriesIcon = (props: IconProps) => {
  return (
    <svg version="1.1" width={props.width} height={props.height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
      <path fill="#fff" d="M4 26h18.667v2h-18.667v-2z"></path>
      <path
        fill="#fff"
        d="M27 25.333c0.92 0 1.667 0.746 1.667 1.667s-0.746 1.667-1.667 1.667c-0.92 0-1.667-0.746-1.667-1.667s0.746-1.667 1.667-1.667z"
      ></path>
      <path fill="#fff" d="M4 18h18.667v2h-18.667v-2z"></path>
      <path
        fill="#fff"
        d="M27 17.333c0.92 0 1.667 0.746 1.667 1.667s-0.746 1.667-1.667 1.667c-0.92 0-1.667-0.746-1.667-1.667s0.746-1.667 1.667-1.667z"
      ></path>
      <path fill="#fff" d="M4 10h18.667v2h-18.667v-2z"></path>
      <path
        fill="#fff"
        d="M27 9.333c0.92 0 1.667 0.746 1.667 1.667s-0.746 1.667-1.667 1.667c-0.92 0-1.667-0.746-1.667-1.667s0.746-1.667 1.667-1.667z"
      ></path>
      <path fill="#fff" d="M4 2h18.667v2h-18.667v-2z"></path>
      <path
        fill="#fff"
        d="M27 1.333c0.92 0 1.667 0.746 1.667 1.667s-0.746 1.667-1.667 1.667c-0.92 0-1.667-0.746-1.667-1.667s0.746-1.667 1.667-1.667z"
      ></path>
    </svg>
  );
};

export const VideosIcon = (props: IconProps) => {
  return (
    <svg
      version="1.1"
      width={props.width}
      height={props.height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
    >
      <path
        fill="#fff"
        d="M0 128l0 768 1024 0 0-768-1024 0zM192 832l-128 0 0-128 128 0 0 128zM192 576l-128 0 0-128 128 0 0 128zM192 320l-128 0 0-128 128 0 0 128zM768 832l-512 0 0-640 512 0 0 640zM960 832l-128 0 0-128 128 0 0 128zM960 576l-128 0 0-128 128 0 0 128zM960 320l-128 0 0-128 128 0 0 128zM384 320l0 384 256-192z"
      />
    </svg>
  );
};

export const BundleIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1024 1024"
    width={props.width}
    height={props.height}
    fill="currentColor"
  >
    <path d="M1077.312 512.589c-0.654 0.033-1.335 0.052-2.001 0.052-20.099-0.002-36.681-15.796-37.762-35.955-12.314-230.379-180.551-430.749-400.030-476.433-30.598-6.368-62.167-9.597-93.826-9.597-46.553 0-92.979 6.882-137.988 20.457-45.374 13.684-88.285 33.866-127.539 59.984-102.138 67.977-171.215 169.694-194.506 286.415-22.185 111.062 1.622 229.574 65.32 325.145 60.995 91.523 151.78 153.069 255.631 173.3 23.007 4.473 46.687 6.741 70.384 6.739 38.11 0 76.071-5.765 112.831-17.135 37.052-11.461 71.965-28.337 103.773-50.16 79.852-54.802 133.124-135.753 150.006-227.944 15.926-86.916-4.116-178.88-54.986-252.312-47.874-69.138-117.99-114.817-197.43-128.62-15.535-2.705-31.48-4.074-47.397-4.074-59.442 0-118.83 19.206-167.219 54.084-57.598 41.532-95.142 101.637-105.717 169.244-9.81 62.758 6.362 128.206 44.368 179.565 34.606 46.791 83.921 76.695 138.862 84.202 8.267 1.139 16.725 1.716 25.126 1.716 42.312 0 83.936-14.478 117.204-40.768 35.451-28.027 57.408-67.076 61.826-109.954 3.973-37.955-8.349-77.932-32.961-106.922-14.757-17.365-40.474-38.495-79.205-40.563-1.434-0.068-2.834-0.101-4.221-0.101-24.617 0-49.315 10.005-66.065 26.763-13.84 13.806-20.443 30.040-19.613 48.24 0.591 12.655 8.509 27.793 18.025 34.473 2.1 1.482 5.005 3.195 8.709 3.195 1.956 0 3.471-0.487 4.285-0.748 3.677-1.169 7.492-1.762 11.322-1.762 16.566 0 31.043 10.693 36.024 26.609 6.258 19.981-4.815 41.365-24.684 47.67-8.928 2.828-18.047 4.263-27.097 4.263-18.146 0-36.064-5.85-51.818-16.92-28.827-20.251-48.537-56.866-50.218-93.282-1.822-39.353 13.035-76.893 41.835-105.705 15.144-15.139 34.003-27.588 54.536-36 20.493-8.397 42.799-12.833 64.507-12.833 2.819 0 5.666 0.074 8.462 0.22 51.12 2.73 98.242 26.564 132.676 67.11 38.338 45.149 56.811 104.991 50.683 164.18-6.603 63.517-38.683 120.992-90.336 161.833-46.504 36.732-104.805 56.963-164.156 56.963-11.713 0-23.504-0.799-35.043-2.374-75.237-10.303-142.467-50.84-189.301-114.15-50.045-67.65-71.318-153.941-58.364-236.75 13.752-87.868 62.175-165.717 136.35-219.205 61.071-44.034 136.183-68.286 211.499-68.286 20.141 0 40.321 1.729 59.982 5.139 99.457 17.278 187.016 74.13 246.543 160.080 62.358 89.998 86.893 202.824 67.315 309.547-20.599 112.31-85.152 210.664-181.767 276.946-38.028 26.102-79.802 46.287-124.16 59.996-44.019 13.605-89.494 20.503-135.162 20.503-28.484 0-56.941-2.73-84.578-8.114-123.745-24.099-231.717-97.111-304.026-205.583-74.83-112.26-102.768-251.656-76.652-382.444 27.318-136.769 107.904-255.687 226.914-334.847 45.394-30.201 95.052-53.538 147.595-69.363 52.11-15.693 105.879-23.65 159.816-23.65 36.629 0 73.279 3.747 108.93 11.136 252.495 52.537 446.025 282.49 460.164 546.778 0.547 10.145-2.863 19.891-9.6 27.446-6.738 7.554-15.999 12.014-26.074 12.561z" />
  </svg>
);

export const InkedIcon = (props: IconProps) => {
  return (
    <svg version="1.1" width={props.width} height={props.height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
      <path
        fill="#fff"
        d="M18.74 3.137l0.223-2.816-1.869 2.119c-2.417 2.741-4.512 5.889-6.127 9.183-0.002 0.003-0.318 0.647-0.409 0.834-2.177 4.457-2.94 7.282-2.381 11.179 0.601 4.256 4.098 7.645 8.172 7.645 4.44 0 8.245-3.484 8.245-7.773h-0.942v0.942h0.911l0.051-0.888c0.189-3.279-1.332-7.624-3.72-11.955l-1.65 0.91c2.229 4.043 3.652 8.108 3.489 10.937l0.941 0.054v-0.942h-0.964v0.942c0 3.21-2.925 5.889-6.36 5.889-3.089 0-5.831-2.657-6.307-6.026-0.493-3.437 0.183-5.94 2.209-10.086 0.091-0.185 0.406-0.827 0.408-0.832 1.542-3.145 3.543-6.152 5.848-8.766l-1.646-0.698c-0.223 2.822 0.785 6.633 2.382 9.528l1.65-0.91c-1.431-2.594-2.344-6.049-2.153-8.47z"
      ></path>
    </svg>
  );
};

export const CurrentIcon = (props: IconProps) => {
  return (
    <svg version="1.1" width={props.width} height={props.height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
      <path fill="#fff" d="M4 2.667h2v26.667h-2v-26.667z"></path>
      <path fill="#fff" d="M9.333 22.667h2v6.667h-2v-6.667z"></path>
      <path fill="#fff" d="M14.667 16h2v13.333h-2v-13.333z"></path>
      <path fill="#fff" d="M20 6.667h2v22.667h-2v-22.667z"></path>
      <path fill="#fff" d="M25.333 12h2v17.333h-2v-17.333z"></path>
    </svg>
  );
};

export const LogbookIcon = (props: IconProps) => {
  return (
    <svg width={props.width} height={props.height} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 32 32">
      <g transform="matrix(1 0 0 1 16 16)" id="c38fe36b-cc76-471a-b7ea-7797a1e70e87">
        <rect fillOpacity="0" vectorEffect="non-scaling-stroke" x="-16" y="-16" rx="0" ry="0" width="32" height="32" />
      </g>
      <g id="852f7395-6a20-48a4-a0f5-a83527412a8d"></g>
      <g transform="matrix(0.08 0 0 0.08 16 16)">
        <path
          fill="#fff"
          transform=" translate(-207.98, -224)"
          d="M 409.75 119.5 C 416 128.5 417.75 140.25 414.25 151.75 L 345.5 378.25 C 339.25 399.5 317.25 416 295.75 416 L 65 416 C 39.5 416 12.25 395.75 3 369.75 C -1 358.5 -1 347.5 2.5 338 C 3 333 4 328 4.25 322 C 4.5 318 2.25 314.75 2.75 311.75 C 3.75 305.75 9 301.5 13 294.75 C 20.5 282.25 29 262 31.75 249 C 33 244.25 30.5 238.75 31.75 234.5 C 33 229.75 37.75 226.25 40.25 221.75 C 47 210.25 55.75 188 57 176.25 C 57.5 171 55 165.25 56.5 161.25 C 58.25 155.5 63.75 153 67.5 148 C 73.5 139.75 83.5 116 85 102.75 C 85.5 98.5 83 94.25 83.75 89.75 C 84.75 85 90.75 80 94.75 74.25 C 105.25 58.75 107.25 24.5 139 33.5 L 138.75 34.25 C 143 33.25 147.25 32 151.5 32 L 341.75 32 C 353.5 32 364 37.25 370.25 46 C 376.75 55 378.25 66.75 374.75 78.5 L 306.25 305 C 294.5 343.5 288 352 256.25 352 L 39 352 C 35.75 352 31.75 352.75 29.5 355.75 C 27.5 358.75 27.25 361 29.25 366.5 C 34.25 381 51.5 384 65.25 384 L 296 384 C 305.25 384 316 378.75 318.75 369.75 L 393.75 123 C 395.25 118.25 395.25 113.25 395 108.75 C 400.75 111 406 114.5 409.75 119.5 z M 143.75 120 C 142.25 124.5 144.75 128 149.25 128 L 301.25 128 C 305.5 128 310.25 124.5 311.75 120 L 317 104 C 318.5 99.5 316 96 311.5 96 L 159.5 96 C 155.25 96 150.5 99.5 149 104 z M 123 184 C 121.5 188.5 124 192 128.5 192 L 280.5 192 C 284.75 192 289.5 188.5 291 184 L 296.25 168 C 297.75 163.5 295.25 160 290.75 160 L 138.75 160 C 134.5 160 129.75 163.5 128.25 168 z"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};

export const InsightsIcon = (props: IconProps) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 1000 829"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          fill="#fff"
          d="M677.5,339.8L876,340.2C897.8,340.2 918.3,348.8 933.7,364.2C949.1,379.7 957.6,400.2 957.5,422.1C957.5,443.9 949,464.4 933.5,479.8C918.1,495.2 897.6,503.7 875.8,503.7L875.7,503.7L677.2,503.3C655.4,503.3 634.9,494.7 619.5,479.3C604.1,463.8 595.6,443.3 595.7,421.4C595.8,376.4 632.4,339.9 677.4,339.9L677.5,339.9M677.6,312.8L677.4,312.8C617.5,312.8 568.8,361.3 568.7,421.3C568.6,481.4 617.1,530.2 677.2,530.3L875.7,530.7L875.9,530.7C935.9,530.7 984.5,482.2 984.6,422.2C984.7,362.1 936.2,313.3 876.1,313.2L677.6,312.8Z"
        />
      </g>
      <circle fill="#fff" cx="127.8" cy="422" r="108.8" />
      <circle fill="#fff" cx="675.9" cy="421.5" r="108.8" />
      <path
        fill="#fff"
        d="M351.9,531C290.9,531 247.4,482.7 247.4,421.2C247.4,360.2 291.2,311.8 351.9,311.8C396.6,311.8 431,337.6 445.7,375.3L410.9,390C401.1,365 381.4,349.8 351.9,349.8C312.2,349.8 285.5,379.3 285.5,421.1C285.5,463.3 312.1,492.8 351.9,492.8C378.1,492.8 396.1,480.5 407.2,459.2L443.3,471.9C427.7,507.2 395,531 351.9,531Z"
      />
      <path
        fill="#fff"
        d="M480.5,451.5L480.5,356L445.7,356L445.7,318L480.5,318L480.5,277.7L518.6,277.7L518.6,318L567.8,318L567.8,356.1L518.6,356.1L518.6,446.2C518.6,473.7 524.3,486.8 548.9,486.8L568.6,486.8L568.6,524.9L539.5,524.9C497.7,524.9 480.5,501.5 480.5,451.5Z"
      />
      <g>
        <path
          fill="#fff"
          d="M701.9,56.1L739.6,56.1L739.6,261L701.9,261L701.9,229.8C693,246 671.5,267.1 631.7,267.1C575.7,267.1 532.3,220 532.3,158.4C532.3,97.1 575.7,50.1 631.7,50.1C671.5,50.1 693,71.6 701.9,87.4L701.9,56.1ZM701.9,158.3C701.9,116.9 674.7,87.7 635.8,87.7C596.9,87.7 570.1,116.9 570.1,158.3C570.1,200.1 596.9,229.3 635.8,229.3C674.8,229.3 701.9,200.1 701.9,158.3Z"
        />
      </g>
      <path
        fill="#fff"
        d="M27.1,112.6C27.1,77 57.3,47.9 105.5,47.9C172.4,47.9 190.7,99.5 190.7,99.5L159.7,119.2C159.7,119.2 145.8,85.6 105.6,85.6C77.7,85.6 64.6,96.3 64.6,111.4C64.6,124.5 71.4,133.1 93.7,136L127.5,140.1C178,146.7 197.5,170 197.5,200.7C197.5,236.3 168.4,267.1 111.9,267.1C38.3,267.1 21.2,213.4 21.2,213.4L51,194.1C51,194.1 65.3,229.3 111.5,229.3C148.1,229.3 159.7,216.6 159.7,201.4C159.7,187.9 152.1,179.7 126.3,176.4L92.5,172.3C47.8,166.6 27.1,144.1 27.1,112.6Z"
      />
      <path
        fill="#fff"
        d="M479.7,150.7C479.7,108.1 465.9,86 433.2,86C397.5,86 382,110.2 382,157.3L382,261L344.4,261L344.4,150.7C344.4,108.1 330.5,86 297.8,86C262.8,86 247.9,108.9 247.9,154L247.9,260.9L209,260.9L209,55.2L246.8,55.2L246.4,84.6C253.5,69.4 267.9,47.8 303.6,47.8C338.9,47.8 360.8,65 372,101.5L378,85.9C385.1,70.7 404.5,47.8 440.2,47.8C487.9,47.8 518.4,78.9 518.4,147.4L518.4,260.9L479.6,260.9L479.7,150.7Z"
      />
      <path
        fill="#fff"
        d="M967,222.8C942.4,222.8 936.7,209.7 936.7,182.2L936.7,91.6L985.9,91.6L985.9,50.3L936.7,50.3L936.7,13.6L898.6,13.6L898.6,50.3L855.2,50.3C824.1,50.3 806.4,60.9 796.2,84.3L796.2,56.1L758.1,56.1L758.1,260.8L796.2,260.8L796.2,142.1C797,105.2 814.2,91.7 849.9,91.7L865,91.7L865,91.6L898.6,91.6L898.6,187.5C898.6,237.5 915.8,260.8 957.6,260.8L986.7,260.8L986.7,222.7L967,222.7L967,222.8Z"
      />
      <g>
        <path
          fill="#fff"
          d="M52.7,555.9C62.9,555.9 71,563.7 71,574.2C71,584.7 62.9,592.5 52.7,592.5C42.5,592.5 34.4,584.7 34.4,574.2C34.4,563.7 42.5,555.9 52.7,555.9ZM39.3,614.6L66.3,614.6L66.3,761.2L39.3,761.2L39.3,614.6Z"
        />
        <path
          fill="#fff"
          d="M205.7,683.1C205.7,652.9 192.1,637.2 166.8,637.2C139.8,637.2 122.4,653.5 122.4,685.4L122.4,761.2L95.4,761.2L95.4,614.6L122.4,614.6L122.4,637.2C127.9,626.5 144.8,610.2 172.3,610.2C209.2,610.2 232.7,632.3 232.7,680.8L232.7,761.2L205.7,761.2L205.7,683.1Z"
        />
        <path
          fill="#fff"
          d="M254.5,656.1C254.5,630.8 276.6,610.2 311.7,610.2C360.5,610.2 373.8,646.8 373.8,646.8L351.2,660.7C351.2,660.7 341,636.9 311.7,636.9C291.4,636.9 281.8,644.4 281.8,655.2C281.8,664.5 286.7,670.6 303,672.6L327.7,675.5C364.6,680.1 378.8,696.7 378.8,718.5C378.8,743.8 357.6,765.5 316.4,765.5C262.7,765.5 250.2,727.5 250.2,727.5L272,713.9C272,713.9 282.5,738.9 316.1,738.9C342.8,738.9 351.2,729.9 351.2,719.2C351.2,709.6 345.7,703.8 326.8,701.5L302.1,698.6C269.6,694.4 254.5,678.4 254.5,656.1Z"
        />
        <path
          fill="#fff"
          d="M408.1,555.9C418.3,555.9 426.4,563.7 426.4,574.2C426.4,584.7 418.3,592.5 408.1,592.5C397.9,592.5 389.8,584.7 389.8,574.2C389.8,563.7 397.9,555.9 408.1,555.9ZM394.7,614.6L421.7,614.6L421.7,761.2L394.7,761.2L394.7,614.6Z"
        />
        <path
          fill="#fff"
          d="M468.8,758.9C474.3,777.8 489.4,790 510.6,790C539.9,790 558.8,776.9 558.8,742.7L558.8,729.9C553.3,740.6 535.9,755.5 510.3,755.5C474.3,755.5 442.1,724.7 442.1,683.5C442.1,642.3 473.7,610.3 510.3,610.3C536.7,610.3 553.3,625.4 558.8,635.6L558.8,614.7L585.5,614.7L585.5,742.7C585.5,790 554.7,816.5 510.6,816.5C477.2,816.5 449.9,793.6 443.5,767.1L468.8,758.9ZM558.8,683.4C558.8,656.4 540.5,636.4 514.1,636.4C488,636.4 468.2,655.9 468.2,683.4C468.2,710.9 488.5,729.3 514.1,729.3C539.3,729.3 558.8,710.4 558.8,683.4Z"
        />
        <path
          fill="#fff"
          d="M724.8,683.1C724.8,652.9 711.2,637.2 685.9,637.2C658.9,637.2 641.5,653.5 641.5,685.4L641.5,761.2L614.5,761.2L614.5,557.9L641.5,557.9L641.5,637.2C647,626.5 663.9,610.2 691.4,610.2C728.3,610.2 751.8,632.3 751.8,680.8L751.8,761.2L724.8,761.2L724.8,683.1Z"
        />
        <path
          fill="#fff"
          d="M785.2,709.2L785.2,641.5L760.5,641.5L760.5,614.5L785.2,614.5L785.2,571L812.2,571L812.2,614.6L847,614.6L847,641.6L812.2,641.6L812.2,705.5C812.2,725 816.3,734.2 833.7,734.2L847.6,734.2L847.6,761.2L827,761.2C797.4,761.2 785.2,744.6 785.2,709.2Z"
        />
        <path
          fill="#fff"
          d="M860.7,656.1C860.7,630.8 882.8,610.2 917.9,610.2C966.7,610.2 980,646.8 980,646.8L957.4,660.7C957.4,660.7 947.2,636.9 917.9,636.9C897.6,636.9 888,644.4 888,655.2C888,664.5 892.9,670.6 909.2,672.6L933.9,675.5C970.8,680.1 985,696.7 985,718.5C985,743.8 963.8,765.5 922.6,765.5C868.9,765.5 856.4,727.5 856.4,727.5L878.2,713.9C878.2,713.9 888.7,738.9 922.3,738.9C949,738.9 957.4,729.9 957.4,719.2C957.4,709.6 951.9,703.8 933,701.5L908.3,698.6C875.8,694.4 860.7,678.4 860.7,656.1Z"
        />
      </g>
    </svg>
  );
};

export const AdminIcon = (props: IconProps) => {
  return (
    <svg width={props.width} height={props.height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
      <path
        fill="#fff"
        d="M256 768l-128 128h-64v-64l128-128zM320 960h64v-128h-64zM576 640h128v-64h-128zM640 832v64h-64l-128-128 64-64zM0 640h128v-64h-128zM320 384h64v-128h-64zM64 384v-64h64l128 128-64 64zM1010 78l-636.118 636.118c-18.668 18.668-49.214 18.668-67.882 0l-60.118-60.118c-18.668-18.668-18.668-49.214 0-67.882l636.118-636.118c18.668-18.668 49.214-18.668 67.882 0l60.118 60.118c18.668 18.668 18.668 49.214 0 67.882zM480 416l-192 192 64 64 192-192-64-64z"
      />
    </svg>
  );
};

export const PagerDutyIcon = (props: IconProps) => {
  return (
    <svg width={props.width} height={props.height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" >
      <path
        fill="#fff"
        d="M269.74,996.273c-35.433,-7.836 -60.807,-35.72 -65.524,-72.006c-0.81,-6.225 -1.054,-131.451 -0.842,-431.388l0.299,-422.618l2.376,-8.389c8.092,-28.57 26.996,-48.725 54.777,-58.402l9.962,-3.47l463.516,-0l7.865,2.457c29.332,9.163 50.13,30.728 57.965,60.102l2.334,8.751l-0,854.672l-2.268,8.488c-7.827,29.298 -27.975,50.445 -57.507,60.358l-7.341,2.465l-229.66,0.185c-187.495,0.152 -230.816,-0.069 -235.952,-1.205Zm249.292,-60.147c9.609,-5.939 9.344,-20.412 -0.484,-26.404c-2.777,-1.693 -5.285,-2.084 -13.38,-2.084c-8.095,0 -10.603,0.391 -13.381,2.084c-6.977,4.255 -9.5,12.974 -5.929,20.497c3.132,6.602 8.888,8.94 20.964,8.516c6.541,-0.23 9.322,-0.824 12.21,-2.609Zm251.451,-93.513l0,-681.641l-534.825,0l-0,681.641l534.825,-0Zm-273.297,-106.429c-9.09,-1.977 -14.635,-5.128 -21.96,-12.479c-7.58,-7.605 -11.766,-15.808 -12.908,-25.293c-2.469,-20.509 7.205,-38.757 25.256,-47.643c12.666,-6.235 30.069,-5.567 42.34,1.624c6.441,3.775 15.865,14.214 19.035,21.088c2.504,5.427 2.801,7.325 2.841,18.122c0.042,11.444 -0.128,12.423 -3.321,19.163c-6.374,13.457 -19.785,23.545 -34.506,25.956c-7.594,1.243 -8.76,1.206 -16.777,-0.538Zm-2.415,-130.276c-2.547,-0.899 -6.652,-3.657 -9.124,-6.129c-5.735,-5.735 -7.383,-11.499 -8.229,-28.774c-0.353,-7.21 -0.854,-16.648 -1.114,-20.974c-0.817,-13.61 -3.755,-66.901 -5.782,-104.867c-0.631,-11.824 -1.772,-31.644 -2.535,-44.045c-0.832,-13.52 -1.329,-40.389 -1.242,-67.115l0.146,-44.569l2.737,-5.768c7.937,-16.724 25.878,-26.2 43.723,-23.092c17.705,3.083 30.027,15.899 32.886,34.205c1.299,8.315 0.569,75.737 -1.111,102.669c-0.576,9.228 -1.323,21.97 -1.661,28.314c-0.338,6.345 -1.062,19.322 -1.61,28.839c-0.547,9.517 -1.955,35.235 -3.129,57.153c-3.258,60.869 -4.159,74.097 -5.347,78.509c-1.658,6.158 -9.499,13.955 -15.964,15.874c-6.688,1.987 -16.656,1.885 -22.644,-0.23l-0,0Zm55.793,-513.025c4.332,-4.041 4.416,-4.251 4.416,-11.086c-0,-6.835 -0.084,-7.045 -4.416,-11.087l-4.417,-4.119l-81.959,0l-4.416,4.119c-4.333,4.042 -4.416,4.252 -4.416,11.087c-0,6.835 0.083,7.045 4.416,11.086l4.416,4.12l81.959,-0l4.417,-4.12Zm-485.317,570.568c-8.388,-5.14 -28.473,-30.519 -38.624,-48.805c-19.726,-35.535 -29.294,-78.921 -25.977,-117.791c1.518,-17.782 5.217,-36.548 10.14,-51.435c8.251,-24.954 24.767,-53.453 42.745,-73.759c10.458,-11.812 15.167,-14.368 23.107,-12.541c7.869,1.812 13.288,10.205 11.779,18.245c-0.494,2.635 -3.45,6.85 -10.181,14.52c-22.105,25.187 -36.083,52.791 -43.087,85.091c-2.002,9.232 -2.314,13.889 -2.333,34.779c-0.018,21.236 0.265,25.436 2.37,35.13c7.134,32.862 22.058,62.419 42.965,85.092c11.233,12.182 12.922,18.061 7.666,26.677c-3.815,6.253 -14.229,8.682 -20.57,4.797Zm864.763,0.142c-6.402,-3.154 -9.784,-11.64 -7.454,-18.701c0.726,-2.199 4.858,-7.741 9.628,-12.915c21.369,-23.174 37.486,-55.704 43.457,-87.713c2.98,-15.976 2.733,-52.595 -0.454,-67.288c-7.007,-32.304 -20.983,-59.905 -43.088,-85.091c-6.731,-7.67 -9.687,-11.885 -10.181,-14.52c-1.508,-8.04 3.911,-16.433 11.78,-18.244c7.939,-1.828 12.649,0.728 23.107,12.54c17.977,20.306 34.493,48.805 42.744,73.759c8.461,25.586 12.199,55.515 10.153,81.288c-3.279,41.307 -16.805,78.317 -40.113,109.756c-9.246,12.473 -20.981,25.258 -25.172,27.425c-3.84,1.986 -10.034,1.859 -14.407,-0.296Zm-803.995,-58.929c-3.877,-1.674 -16.597,-16.412 -22.735,-26.344c-6.786,-10.98 -13.428,-27.085 -15.991,-38.775c-2.63,-11.999 -3.24,-36.191 -1.207,-47.857c4.246,-24.356 14.403,-45.683 30.36,-63.746c9.896,-11.202 19.085,-12.894 27.006,-4.973c7.825,7.825 6.404,15.473 -5.389,29.011c-7.653,8.785 -15.798,24.629 -18.868,36.704c-3.086,12.136 -3.709,27.178 -1.622,39.124c3.123,17.869 9.776,31.721 22.667,47.189c4.667,5.6 7.505,10.017 7.946,12.367c0.938,5.002 -2,12.355 -6.105,15.278c-3.517,2.505 -12.362,3.618 -16.062,2.022Zm744.093,-0.901c-4.006,-2.158 -8.391,-9.394 -8.388,-13.842c0.001,-3.741 2.581,-8.05 10.82,-18.077c8.217,-10 15.35,-23.737 18.679,-35.97c1.845,-6.779 2.288,-11.308 2.311,-23.595c0.032,-17.629 -1.806,-26.207 -8.708,-40.646c-4.807,-10.056 -8.114,-15.027 -16.081,-24.173c-3.556,-4.082 -6.022,-7.993 -6.438,-10.209c-2.18,-11.62 8.95,-21.906 19.823,-18.318c5.28,1.743 9.149,5.285 17.324,15.863c12.622,16.331 21.129,35.842 24.807,56.892c2.402,13.749 1.436,37.422 -2.082,51.003c-5.432,20.968 -17.494,42.795 -30.954,56.013c-5.856,5.751 -6.717,6.231 -11.879,6.619c-4.069,0.305 -6.55,-0.114 -9.234,-1.56Z"
      />
    </svg>
  );
};



export const SettingsIcon = ({ width, height, color, ...restOfProps }: IconProps) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={width || "35"}
      height={height || "35"}
      viewBox="0 0 32 32"
      {...restOfProps}
    >
      <path
        fill={color || "#fff"}
        d="M26.667 17.77v-3.54l-2.039-0.366c-0.216-0.877-0.562-1.7-1.017-2.454l1.183-1.701-2.503-2.503-1.701 1.183c-0.754-0.455-1.577-0.8-2.454-1.017l-0.366-2.039h-3.54l-0.366 2.039c-0.876 0.216-1.7 0.562-2.453 1.017l-1.702-1.183-2.503 2.503 1.182 1.701c-0.455 0.753-0.8 1.577-1.016 2.454l-2.039 0.367v3.539l2.039 0.367c0.216 0.877 0.562 1.7 1.016 2.453l-1.182 1.701 2.503 2.503 1.702-1.183c0.752 0.455 1.576 0.801 2.453 1.017l0.366 2.039h3.54l0.366-2.039c0.877-0.216 1.7-0.562 2.454-1.017l1.701 1.183 2.503-2.503-1.183-1.701c0.455-0.753 0.801-1.577 1.016-2.453l2.040-0.367zM22.774 16c0 3.741-3.033 6.775-6.774 6.775s-6.775-3.034-6.775-6.775c0-3.741 3.034-6.774 6.774-6.774s6.774 3.033 6.774 6.774v0z"
      ></path>
    </svg>
  );
};

export const DeleteIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" x="0" y="0" viewBox="0 0 256 256">
      <path
        fill="#fff"
        strokeMiterlimit="10"
        d="M10 2L9 3H3v2h18V3h-6l-1-1zM4.365 7l1.703 15h11.864l1.703-15z"
        fontFamily="none"
        fontSize="none"
        fontWeight="none"
        textAnchor="none"
        transform="scale(10.66667)"
      ></path>
    </svg>
  );
};

export const EditIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" x="0" y="0" viewBox="0 0 256 256">
      <path
        fill="#fff"
        strokeMiterlimit="10"
        d="M18 2l-2.414 2.414 4 4L22 6zm-3.924 3.924L3 17v4h4L18.076 9.924z"
        fontFamily="none"
        fontSize="none"
        fontWeight="none"
        textAnchor="none"
        transform="scale(10.66667)"
      ></path>
    </svg>
  );
};

export const BellIcon = (props: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      enableBackground="new 0 0 512 512"
      version="1.1"
      viewBox="0 0 512 512"
      xmlSpace="preserve"
    >
      <path
        fill={props.color}
        d="M381.7 225.9c0-97.6-52.5-130.8-101.6-138.2 0-.5.1-1 .1-1.6 0-12.3-10.9-22.1-24.2-22.1-13.3 0-23.8 9.8-23.8 22.1 0 .6 0 1.1.1 1.6-49.2 7.5-102 40.8-102 138.4 0 113.8-28.3 126-66.3 158h384c-37.8-32.1-66.3-44.4-66.3-158.2zM256.2 448c26.8 0 48.8-19.9 51.7-43H204.5c2.8 23.1 24.9 43 51.7 43z"
      ></path>
    </svg>
  );
};

export const PasswordIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="#fff" width="20px" height="20px" viewBox="0 0 512 512">
      <g id="Password">
        <path d="M391,233.9478H121a45.1323,45.1323,0,0,0-45,45v162a45.1323,45.1323,0,0,0,45,45H391a45.1323,45.1323,0,0,0,45-45v-162A45.1323,45.1323,0,0,0,391,233.9478ZM184.123,369.3794a9.8954,9.8954,0,1,1-9.8964,17.1387l-16.33-9.4287v18.8593a9.8965,9.8965,0,0,1-19.793,0V377.0894l-16.33,9.4287a9.8954,9.8954,0,0,1-9.8964-17.1387l16.3344-9.4307-16.3344-9.4306a9.8954,9.8954,0,0,1,9.8964-17.1387l16.33,9.4282V323.9487a9.8965,9.8965,0,0,1,19.793,0v18.8589l16.33-9.4282a9.8954,9.8954,0,0,1,9.8964,17.1387l-16.3344,9.4306Zm108,0a9.8954,9.8954,0,1,1-9.8964,17.1387l-16.33-9.4287v18.8593a9.8965,9.8965,0,0,1-19.793,0V377.0894l-16.33,9.4287a9.8954,9.8954,0,0,1-9.8964-17.1387l16.3344-9.4307-16.3344-9.4306a9.8954,9.8954,0,0,1,9.8964-17.1387l16.33,9.4282V323.9487a9.8965,9.8965,0,0,1,19.793,0v18.8589l16.33-9.4282a9.8954,9.8954,0,0,1,9.8964,17.1387l-16.3344,9.4306Zm108,0a9.8954,9.8954,0,1,1-9.8964,17.1387l-16.33-9.4287v18.8593a9.8965,9.8965,0,0,1-19.793,0V377.0894l-16.33,9.4287a9.8954,9.8954,0,0,1-9.8964-17.1387l16.3344-9.4307-16.3344-9.4306a9.8954,9.8954,0,0,1,9.8964-17.1387l16.33,9.4282V323.9487a9.8965,9.8965,0,0,1,19.793,0v18.8589l16.33-9.4282a9.8954,9.8954,0,0,1,9.8964,17.1387l-16.3344,9.4306Z" />
        <path d="M157.8965,143.9487a98.1035,98.1035,0,1,1,196.207,0V214.147h19.793V143.9487a117.8965,117.8965,0,0,0-235.793,0V214.147h19.793Z" />
      </g>
    </svg>
  );
};

export const InvitationIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="#fff" width="20px" height="20px" viewBox="0 0 1920 1920">
      <path
        d="m1387.688 1315.136 387.307 498.24H144.275l387.413-498.24 89.28 71.573h677.44l89.28-71.573ZM53 932.235l395.413 316.48L53 1756.98V932.235Zm1813.333.053v824.64l-395.413-508.267 395.413-316.373ZM1546.408-.011v498.347l319.893 277.333v19.947l-426.666 341.44v-1030.4h-960v1030.4L52.968 795.616v-19.947l320-277.333V-.011h1173.44ZM1013 266.667v266.666h266.667V640H1013v266.667H906.333V640H639.667V533.333h266.666V266.667H1013Z"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const MailIcon = ({ width = "20px", height = "20px", color = "#fff" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      width={width}
      height={height}
      viewBox="-4 0 32 32"
      version="1.1"
    >
      <path d="M24 8.375l-12 10.281-12-10.281v-0.594h24v0.594zM24 22.875l-7.938-5.719 7.938-6.875v12.594zM0 10.281l7.938 6.875-7.938 5.719v-12.594zM12 20.688l3.281-2.875 8.719 6.281v0.125h-24v-0.125l8.719-6.281z" />
    </svg>
  );
};

export const HomeIcon = ({ width = "20px", height = "20px", color = "#fff" }: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill={color} width={width} height={height} viewBox="0 0 24 24">
      <path d="M12.97 2.59a1.5 1.5 0 00-1.94 0l-7.5 6.363A1.5 1.5 0 003 10.097V19.5A1.5 1.5 0 004.5 21h4.75a.75.75 0 00.75-.75V14h4v6.25c0 .414.336.75.75.75h4.75a1.5 1.5 0 001.5-1.5v-9.403a1.5 1.5 0 00-.53-1.144l-7.5-6.363z" />
    </svg>
  );
};

export const FacebookIcon = ({ width = "20px", height = "20px", color = "#fff" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      width={width}
      height={height}
      version="1.1"
      id="Layer_1"
      viewBox="0 0 310 310"
      xmlSpace="preserve"
    >
      <g id="XMLID_834_">
        <path
          id="XMLID_835_"
          d="M81.703,165.106h33.981V305c0,2.762,2.238,5,5,5h57.616c2.762,0,5-2.238,5-5V165.765h39.064   c2.54,0,4.677-1.906,4.967-4.429l5.933-51.502c0.163-1.417-0.286-2.836-1.234-3.899c-0.949-1.064-2.307-1.673-3.732-1.673h-44.996   V71.978c0-9.732,5.24-14.667,15.576-14.667c1.473,0,29.42,0,29.42,0c2.762,0,5-2.239,5-5V5.037c0-2.762-2.238-5-5-5h-40.545   C187.467,0.023,186.832,0,185.896,0c-7.035,0-31.488,1.381-50.804,19.151c-21.402,19.692-18.427,43.27-17.716,47.358v37.752H81.703   c-2.762,0-5,2.238-5,5v50.844C76.703,162.867,78.941,165.106,81.703,165.106z"
        />
      </g>
    </svg>
  );
};

export const PlusIcon = ({ width = "20px", height = "20px", color = "#fff" }: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill={color} width={width} height={height} viewBox="0 0 1024 1024">
      <path d="M446.86 690.31v-174.545h-349.091c-38.56 0-69.818-31.259-69.818-69.818s31.259-69.818 69.818-69.818h349.091v-349.091c0-93.091 139.636-93.091 139.636 0v349.091h349.091c38.56 0 69.818 31.259 69.818 69.818s-31.259 69.818-69.818 69.818h-349.091v349.091c0 93.091-139.636 93.091-139.636 0v-174.545z" />
    </svg>
  );
};

export const DiscIcon = ({ width = "20px", height = "20px", color = "#fff" }: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill={color} width={width} height={height} viewBox="0 0 1024 1024">
      <path d="M1024 426.667c0-282.77-229.23-512-512-512s-512 229.23-512 512c0 282.77 229.23 512 512 512s512-229.23 512-512z" />
    </svg>
  );
};

export const HexagonIcon = ({ width = "20px", height = "20px", color = "#fff" }: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill={color} width={width} height={height} viewBox="0 0 912 928.187">
      <path d="M491.824 928.187c-19.444 11.114-50.913 11.176-70.442 0.051l-385.822-219.796c-19.46-11.086-35.249-38.294-35.266-60.703l-0.327-439.285c-0.017-22.439 15.664-49.6 35.177-60.753l385.506-220.353c19.444-11.114 50.914-11.176 70.443-0.051l385.827 219.793c19.46 11.086 35.25 38.294 35.266 60.703l0.321 439.29c0.016 22.439-15.664 49.6-35.177 60.754l-385.506 220.35z" />
    </svg>
  );
};

export const CheckmarkIcon = ({ width = "20px", height = "20px", color = "#fff" }: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill={color} width={width} height={height} viewBox="0 0 1024 1024">
      <g transform="scale(1, -1)">
        <path d="M909.722 857.6l-639.59-639.642-197.734 197.734-72.397-72.397 270.131-270.131 711.987 711.987z" />
      </g>
    </svg>
  );
};

export const MenuIcon = ({ width = "20px", height = "20px", color = "#fff" }: IconProps) => {
  return (
    <svg
      fill={color}
      width={width}
      height={height}
      viewBox="-5 -7 24 24"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMinYMin"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M1 0h12a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2zm0 8h12a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2zm0-4h12a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2z"></path>
      </g>
    </svg>
  );
};

export const ArrowIcon = ({ width = "20px", height = "20px", color = "#fff" }: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000" fill={color} width={width} height={height}>
      <path d="M247.778 399.366c3.030-4.442 6.713-8.548 11.037-12.175l404.953-339.796c25.123-21.081 63.105-17.869 84.414 7.527 21.458 25.573 18.065 63.2-7.246 84.439l-374.291 314.068 350.281 293.92c25.123 21.081 28.555 59.043 7.246 84.439-21.458 25.573-59.103 28.765-84.414 7.527l-404.953-339.796c-25.123-21.081-28.555-59.043-7.246-84.439 5.758-6.862 12.682-12.113 20.22-15.712v0 0z" />
    </svg>
  );
};

export const SaveIcon = ({ width = "20px", height = "20px", color = "#fff" }: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" fill={color} width={width} height={height}>
      <path d="M896 960h-896v-1024h1024v896l-128 128zM512 832h128v-256h-128v256zM896 64h-768v768h64v-320h576v320h74.978l53.022-53.018v-714.982z" />
    </svg>
  );
};

export const SearchIcon = ({ width = "20px", height = "20px", color = "#fff" }: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72" fill={color} width={width} height={height}>
      <path d="M 31 11 C 19.973 11 11 19.973 11 31 C 11 42.027 19.973 51 31 51 C 34.974166 51 38.672385 49.821569 41.789062 47.814453 L 54.726562 60.751953 C 56.390563 62.415953 59.088953 62.415953 60.751953 60.751953 C 62.415953 59.087953 62.415953 56.390563 60.751953 54.726562 L 47.814453 41.789062 C 49.821569 38.672385 51 34.974166 51 31 C 51 19.973 42.027 11 31 11 z M 31 19 C 37.616 19 43 24.384 43 31 C 43 37.616 37.616 43 31 43 C 24.384 43 19 37.616 19 31 C 19 24.384 24.384 19 31 19 z" />
    </svg>
  );
};

export const InkButton = ({ width = "20px", height = "20px", color = "#fff" }: IconProps) => (
  <svg width={width} height={height} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" fill={color}>
    <path d="M557.816 938.667c-86.008-99.73-159.217-213.136-215.12-329.765-56.658-118.173-121.718-246.027-97.143-421.275 18.806-136.304 128.105-251.2 260.101-251.2 138.635 0 262.356 110.576 262.356 251.010 8.137 130.4-65.677 303.604-128.734 420.571-50.511 93.663-89.371 228.315-81.46 330.659z" />
  </svg>
);

export const HeaderTestIcon = ({ width = "20px", height = "20px", color = "#fff" }: IconProps) => (
  <svg width={width} height={height} fill={color} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
    <path d="M568.889 53.817v788.309c192.74-27.648 341.333-193.877 341.333-394.126 0-200.306-148.594-366.478-341.333-394.183zM568.889 956.644v3.356h-113.778v-3.356c-255.602-28.444-455.111-245.589-455.111-508.644s199.509-480.256 455.111-508.644v-3.356h113.778v3.356c255.602 28.388 455.111 245.589 455.111 508.644s-199.509 480.199-455.111 508.644z"></path>
  </svg>
);

export const TwitterIcon = ({ width = "20px", height = "20px", color = "#fff" }: IconProps) => (
  <svg width={width} height={height} fill={color} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
    <path d="M658.534 768c-86.826 0-157.216-71.751-157.216-160.251 0-12.56 1.39-24.789 4.070-36.52-130.658 6.683-246.5 70.483-324.043 167.44-13.532-23.669-21.283-51.197-21.283-80.569 0-55.594 27.755-104.646 69.938-133.386-25.77 0.831-50.012 8.040-71.208 20.046-0.011-0.671-0.014-1.34-0.014-2.017 0-77.646 54.192-142.417 126.112-157.137-13.193-3.66-27.082-5.62-41.419-5.62-10.133 0-19.979 1.006-29.579 2.874 20.004-63.666 78.064-110 146.859-111.294-53.805-42.98-121.593-68.6-195.249-68.6-12.689 0-25.204 0.76-37.503 2.237 69.574-45.469 152.213-71.997 240.995-71.997 289.174 0 447.304 244.191 447.304 455.963 0 6.946-0.154 13.857-0.454 20.729 30.714 22.597 57.367 50.823 78.445 82.96-28.195-12.746-58.491-21.363-90.296-25.234 32.461 19.831 57.39 51.237 69.126 88.66-30.375-18.366-64.021-31.703-99.832-38.891-28.677 31.149-69.538 50.609-114.754 50.609z"></path>
  </svg>
);

export const InstagramIcon = ({ width = "20px", height = "20px", color = "#fff" }: IconProps) => (
  <svg width={width} height={height} fill={color} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
    <path d="M844.147 810.667h-670.694c-25.101 0-45.453-20.352-45.453-45.453v-670.694c0-25.101 20.352-45.453 45.453-45.453h670.694c25.101 0 45.453 20.352 45.453 45.453v670.694c0 25.101-20.352 45.453-45.453 45.453v0zM411.597 518.059c23.795 26.957 58.496 44.083 97.203 44.083 38.669 0 73.37-17.126 97.19-44.083 20.186-22.886 32.538-52.813 32.538-85.645 0-71.526-58.202-129.728-129.728-129.728-71.539 0-129.741 58.202-129.741 129.728 0 32.819 12.352 62.758 32.538 85.645v0zM809.421 129.246h-601.254v388.813h109.184c-11.75-26.202-18.458-55.13-18.458-85.645 0-115.75 94.17-209.894 209.907-209.894s209.894 94.144 209.894 209.894c0 30.515-6.707 59.456-18.458 85.645h109.184v-388.813zM809.421 646.085c0-20.198-16.371-36.57-36.582-36.57h-47.782c-20.224 0-36.608 16.371-36.608 36.57v47.834c0 20.198 16.384 36.57 36.608 36.57h47.782c20.211 0 36.582-16.371 36.582-36.57v-47.834z"></path>
  </svg>
);
export const NewsletterIcon = ({ width = "20px", height = "20px", color = "#fff" }: IconProps) => (
  <svg width={width} height={height} fill={color} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
    <path d="M128 618.667v-448l213.76 222.4-213.76 225.6zM896 682.667h-768l384-416 384 416zM651.2 360.107l-139.2-157.44-146.56 164.16-173.44-196.16h640l-180.8 189.44zM896 170.667v448l-220.48-232.64 220.48-215.36z"></path>
  </svg>
);
export const LinkedinIcon = ({ width = "20px", height = "20px", color = "#fff" }: IconProps) => (
  <svg
    width={width}
    height={height}
    fill={color}
    viewBox="0 0 1024 1024"
    xmlns="http://www.w3.org/2000/svg"
    transform="rotate(-180) scale(-1,1)"
  >
    <path d="M162.312 79.701l-14.198 13.263 0.144 349.023c0.118 282.974 1.295 350.537 6.218 357.023 5.695 7.502 28.844 8 371.692 8h365.619l5.305-11.644c7.403-16.249 7.594-688.483 0.198-702.943-2.809-5.492-9.494-13.539-14.857-17.884-9.045-7.327-34.933-7.906-357.839-8l-348.088-0.102-14.198 13.263zM372.114 356.724v180.571h-114.286v-361.143h114.286v180.571zM554.997 280.153c0.027 109.451 2.829 130.465 20.069 150.508 8.772 10.198 15.208 12.576 38.612 14.269 21.299 1.54 30.947 0.157 39.929-5.728 22.44-14.703 24.794-29.028 24.794-150.902v-112.147h114.286v117.34c0 154.335-6.534 190.913-39.581 221.567-22.961 21.299-42.425 28.346-84.086 30.443-33.132 1.668-42.715 0.411-62.819-8.237-13.048-5.613-30.94-18.194-39.761-27.958l-16.038-17.752v45.741h-109.714v-361.143h114.286l0.026 104zM342.447 594.163c17.277 7.219 32.666 28.665 36.992 51.553 4.5 23.809-12.473 53.401-37.608 65.569-69.505 33.647-126.928-55.807-69.579-108.391 17.424-15.976 44.728-19.372 70.195-8.731z"></path>
  </svg>
);

export const YoutubeIcon = ({ width = "20px", height = "20px", color = "#fff" }: IconProps) => (
  <svg width={width} height={height} fill={color} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
    <path d="M935.392 618.189c0 0-8.481 59.584-34.368 85.792-32.864 34.398-69.758 34.591-86.623 36.64-120.864 8.704-302.144 8.704-302.144 8.704h-0.416c0 0-181.344 0-302.271-8.704-16.896-2.048-53.697-2.207-86.591-36.607-25.888-26.211-34.303-85.792-34.303-85.792s-8.672-69.888-8.672-139.81v-65.568c0-69.952 8.672-139.81 8.672-139.81s8.416-59.552 34.303-85.792c32.864-34.398 76-33.344 95.267-36.928 69.153-6.623 293.79-8.672 293.79-8.672s181.504 0.285 302.367 9.056c16.864 1.984 53.761 2.144 86.623 36.575 25.92 26.207 34.368 85.792 34.368 85.792s8.609 69.888 8.609 139.81v65.568c0 69.888-8.609 139.745-8.609 139.745zM430.848 343.499l-0.032 220.864 212.448-110.784-212.416-110.080z"></path>
  </svg>
);

export const FacebookThinIcon = ({ width = "20px", height = "20px", color = "#fff" }: IconProps) => (
  <svg width={width} height={height} fill={color} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
    <path d="M562.266 870.427v-309.461h100.355l15.022-120.604h-115.376v-77.001c0-34.918 9.366-58.712 57.743-58.712l61.7-0.030v-107.867c-10.677-1.467-47.298-4.752-89.91-4.752-88.955 0-149.857 56.203-149.857 159.421v88.941h-100.609v120.604h100.609v309.461h120.323z"></path>
  </svg>
);

export const LinkIcon = ({ width = "20px", height = "20px", color = "#fff" }: IconProps) => (
  <svg width={width} height={height} fill={color} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
    <path d="M528.32 518.507c-6.4 7.36-13.12 13.76-20.8 18.88-14.4 10.24-31.36 15.68-48.96 15.68h-158.080c-56 0-101.76-56.96-101.76-126.72s45.76-126.72 101.76-126.72h67.2c14.4-32.96 33.92-61.76 57.28-84.48h-124.8c-93.76 0-169.6 94.72-169.6 211.2s76.16 211.2 169.6 211.2h158.080c2.56 0 4.8 0 7.040-0.64 14.4-0.32 28.48-3.52 41.92-8.64 35.2-13.12 65.28-40 86.4-75.52 5.76-8.96 10.56-18.24 14.72-28.16 3.84-8.96 7.36-18.24 9.6-28.16 6.72-22.080 9.92-45.76 9.92-70.4s-3.52-48.32-9.92-70.4h-61.76c-4.16 0-8.64 0.64-12.48 1.6 10.56 19.84 16.32 43.2 16.32 68.8 0 25.28-5.76 48.96-16.32 68.8-4.16 8.64-9.28 16.64-15.36 23.68zM590.080 215.147h-33.6c-2.24 0-4.8 0-7.040 0.64-14.4 0.32-28.8 3.52-41.92 8.32-34.88 13.12-65.28 40-86.4 75.52-5.76 8.96-10.56 18.24-14.4 28.16-3.84 8.96-7.36 18.24-9.6 28.16-6.72 22.080-9.92 45.76-9.92 70.4s3.52 48.32 9.92 70.4h61.76c4.16 0 8.32-0.64 12.48-1.6-10.24-19.84-16.32-43.52-16.32-68.8s6.080-48.96 16.32-68.8c4.48-8.64 9.6-16.32 15.68-23.36 6.080-7.36 12.8-13.44 20.48-18.88 14.4-9.92 31.040-15.68 48.96-15.68h158.4c56 0 101.76 56.96 101.76 126.72s-45.76 126.72-101.76 126.72h-66.88c-14.4 33.28-34.24 62.080-57.6 84.48h124.8c93.76 0 169.6-94.72 169.6-211.2s-76.16-211.2-169.6-211.2h-125.12z"></path>
  </svg>
);

export const ArrowUpIcon = ({ width = "20px", height = "20px", color = "#fff" }: IconProps) => (
  <svg width={width} height={height} fill={color} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
    <path d="M523.456 960l-459.456-498.944 93.76-87.296 301.568 328.448v-766.208h128v766.464l301.76-328.704 93.76 87.296z"></path>
  </svg>
);

export const ArrowLeftIcon = ({ width = "20px", height = "20px", color = "#fff" }: IconProps) => (
  <svg width={width} height={height} fill={color} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 459.456l498.944-459.456 87.296 93.76-328.448 301.568h766.208v128h-766.464l328.704 301.76-87.296 93.76z"></path>
  </svg>
);

export const CloseIcon = ({ width = "20px", height = "20px", color = "#fff" }: IconProps) => (
  <svg width={width} height={height} fill={color} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
    <path d="M433.913 442.266l-334.25 334.25c-22.216 22.216-22.216 58.237 0 80.453s58.237 22.216 80.453 0l334.25-334.25 326.068 326.068c22.216 22.216 58.237 22.216 80.453 0s22.216-58.237 0-80.453l-326.068-326.068 348.659-348.659c22.216-22.216 22.216-58.237 0-80.453s-58.237-22.216-80.453 0l-348.659 348.659-356.841-356.841c-22.216-22.216-58.237-22.216-80.453 0s-22.216 58.237 0 80.453l356.841 356.841z"></path>
  </svg>
);

export const RefreshIcon = ({ width = "20px", height = "20px", color = "#fff" }: IconProps) => (
  <svg width={width} height={height} fill={color} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M511.7,30c-233.833,0 -428.706,166.632 -472.468,387.618l133.714,-0c41.2,-148.57 177.066,-257.785 338.754,-257.785c97.198,0 185.032,39.496 248.612,103.255l-154.53,154.53l387.618,-0l-0,-387.618l-141.123,141.123c-87.16,-87.188 -207.549,-141.123 -340.577,-141.123Zm-481.7,575.782l-0,387.618l141.123,-141.123c87.159,87.188 207.549,141.123 340.577,141.123c233.833,0 428.706,-166.632 472.468,-387.618l-133.714,0c-41.199,148.569 -177.067,257.785 -338.754,257.785c-97.198,-0 -185.032,-39.496 -248.612,-103.255l154.53,-154.53l-387.618,0Z"
      fill={color}
    ></path>
  </svg>
);

export const CopyIcon = ({ width = "20px", height = "20px", color = "#fff" }: IconProps) => (
  <svg width={width} height={height} fill={color} viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M30,126.34c-0,-52.851 43.489,-96.34 96.34,-96.34l481.698,0c52.851,-0 96.34,43.489 96.34,96.34l0,192.679l192.68,0c52.85,0 96.339,43.49 96.339,96.34l0,481.699c0,52.85 -43.489,96.339 -96.339,96.339l-481.699,0c-52.85,0 -96.34,-43.489 -96.34,-96.339l0,-192.68l-192.679,0c-52.851,0 -96.34,-43.489 -96.34,-96.34l0,-481.698Zm385.359,578.038l-0,192.68l481.699,-0l-0,-481.699l-192.68,-0l0,192.679c0,52.851 -43.489,96.34 -96.34,96.34l-192.679,0Zm192.679,-96.34l0,-481.698l-481.698,-0l-0,481.698l481.698,0Z"
      fill={color}
    ></path>
  </svg>
);

export const AuthorImage = ({ author, imageUrl }) => {
  return imageUrl ? (
    <img
      style={{
        borderRadius: "50%",
        display: "block",
        fontSize: 0,
        height: "30px",
        margin: "15px 0 15px -30px",
        width: "30px",
        zIndex: 20,
      }}
      src={imageUrl}
      alt={author}
    />
  ) : (
    ""
  );
};

export const TimezoneNight = () => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="15"
      height="15"
      viewBox="0 0 32 32"
    >
      <path
        fill="#444444"
        d="M22.905 18.894c-5.595 0-10.132-4.536-10.132-10.132 0-1.204 0.211-2.358 0.596-3.429-3.908 1.406-6.703 5.144-6.703 9.536 0 5.596 4.536 10.132 10.132 10.132 4.392 0 8.13-2.795 9.536-6.703-1.071 0.385-2.225 0.596-3.429 0.596z"
      ></path>
    </svg>
  );
};

export const SocialChannelHome = () => {
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <path fill="#444444" d="M25.184 14.163l-9.23-9.184-9.184 9.184v12.858h7.347v-7.347h3.674v7.347h7.347z"></path>
  </svg>;
};

export const NoDataIcon = ({ width = "20px", height = "20px", color = "#fff" }: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 108.67 122.88"
    >
      <defs></defs>
      <path
        style={{ fillRule: "evenodd" }}
        d="M25.14,53.37a2.77,2.77,0,0,0,0,5.54H45.25a2.77,2.77,0,0,0,0-5.54Zm60.48-36.9,6.66,6.69-8,8.14,8,8.14L85.61,46.1l-8-8.09-8,8.1L63,39.43l8-8.14-8-8.15,6.67-6.65,8,8.08,8-8.1ZM77.77,0A30.91,30.91,0,0,1,91,58.82v57.69a6.38,6.38,0,0,1-6.37,6.37H6.37A6.38,6.38,0,0,1,0,116.51V22.4A6.38,6.38,0,0,1,6.37,16h44.3A30.89,30.89,0,0,1,77.77,0Zm7.78,60.81A30.92,30.92,0,0,1,48.32,21.52H6.37a.9.9,0,0,0-.63.26.92.92,0,0,0-.26.63V116.5a.89.89,0,0,0,.89.89H84.65a.9.9,0,0,0,.63-.26.92.92,0,0,0,.26-.63V60.81ZM25.14,92.22a2.74,2.74,0,0,0,0,5.48H63.61a2.74,2.74,0,1,0,0-5.48Zm0-19.41a2.74,2.74,0,0,0,0,5.48H63.61a2.74,2.74,0,0,0,0-5.48Z"
      />
    </svg>
  );
};

export const BoostedIcon = ({ width = "20px", height = "20px", color = "#fff" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      height={height}
      width={width}
      style={{ padding: "2px" }}
      version="1.1"
      id="Layer_1"
      viewBox="0 0 712 712"
      xmlSpace="preserve"
    >
      <path
        style={{ fill: color }}
        d="M95.998,418.909H76.22c-25.706,0-46.545,20.84-46.545,46.545C29.674,491.16,50.514,512,76.22,512  h66.324h188.509c83.413,0,151.273-67.86,151.273-151.273c0-40.609-16.088-77.528-42.22-104.727  c26.132-27.2,42.22-64.118,42.22-104.727C482.326,67.86,414.466,0,331.053,0H142.544H76.22C50.514,0,29.674,20.84,29.674,46.545  s20.84,46.545,46.545,46.545h19.779V256V418.909z M189.089,93.091h141.964c32.082,0,58.182,26.1,58.182,58.182  s-26.1,58.182-58.182,58.182H189.089L189.089,93.091L189.089,93.091z M189.089,302.545h141.964c32.082,0,58.182,26.1,58.182,58.182  s-26.1,58.182-58.182,58.182H189.089L189.089,302.545L189.089,302.545z"
      />
      <path
        style={{ fill: color }}
        d="M189.089,418.909V302.545H256v-93.091h-66.911V93.091H256V0H142.544H76.22  C50.514,0,29.674,20.84,29.674,46.545s20.84,46.545,46.545,46.545h19.779V256v162.909H76.22c-25.706,0-46.545,20.84-46.545,46.545  C29.674,491.16,50.514,512,76.22,512h66.324H256v-93.091H189.089z"
      />
    </svg>
  );
};

export const ArrowIconClosed = ({ width = "20px", height = "20px", color = "#000" }: IconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <polygon points="20,20 80,50 20,80 40,50" fill={color}></polygon>
    </svg>
  );
};
